import Vue from 'vue'
import * as types from '../mutation-types'
import loadingUrl from '../../assets/global/img/ajax-loading.gif'
import VueNotifications from 'vue-notifications'
import miscAPI from '../../api/misc.js'
import vehicleAPI from '../../api/vehicle'
import config from '../../config'
import verintService from '@/api/clients/verintService'



const moment = require("moment");

const initialState = {
  showBlockUI: false,
  loadingImage: loadingUrl,
  loadingMessage: 'loading...',
  searchText: '',
  lastNavigation: '',
  roles: [],
  users: [
  ],
  states: [],
  makes: [],
  models: [],
  fuelTypes: [],
  parts: [],
  componentTypes: [],
  enhancements: [],
  status: [],
  selectedStates: [],
  acceptedDates: [],
  useMitel: localStorage.getItem('useMitel') ? localStorage.getItem('useMitel') : config.use_mitel,
  mitelIsLoggedIn: StorageManager.getJWT("MitelServiceJWT") ? true : false,
  useLiveVox: localStorage.getItem('useLiveVox') ? localStorage.getItem('useLiveVox') : config.use_livevox,
  livevoxIsLoggedIn: StorageManager.getJWT("LivevoxServiceJWT") ? true : false,
  useVerint: config.use_verint,
  verintIsLoggedIn: verintService.token ? true : false,
  enableClipboardCopyOnOutboundDial: localStorage.getItem('enableClipboardCopyOnOutboundDial') ? localStorage.getItem('enableClipboardCopyOnOutboundDial') : config.enable_clipboard_copy_on_outbound_dial
}

const state = Object.assign({}, initialState)

const mutations = {
  [types.LOADED_SUCCESS](state) {
    state.showBlockUI = false
  },
  [types.LOADING_START](state, message) {
    state.loadingMessage = message
    state.showBlockUI = true
  },
  [types.NOTIFY_ERRORS](state, data) {
    if (data.type == 'error')
      VueNotifications.error(data)

    if (data.type == 'success')
      VueNotifications.success(data)

    if (data.type == 'warn')
      VueNotifications.warn(data)

    if (data.type == 'info')
      VueNotifications.info(data)

    state.showBlockUI = false
  },
  [types.RESET_STATE](state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  },
  [types.LOAD_US_STATES](state, values) {
    state.states = values
  },
  [types.LOAD_SELECTEDSTATES](state, values) {
    state.selectedStates = values
  },
  [types.LOAD_MAKES](state, values) {
    state.makes = values
  },
  [types.LOAD_MODELS](state, values) {
    state.models = values
  },
  [types.LOAD_FUEL_TYPES](state, values) {
    state.fuelTypes = values
  },
  [types.LOAD_ENHANCEMENTS](state, values) {
    state.enhancements = values;
    state.wizardData.quote_info.missing_parts = values;
  },
  [types.LOAD_STATUS](state, values) {
    state.status = values
  },
  [types.LOAD_ACCEPTEDDATES](state, values) {
    state.acceptedDates = values
  },
  [types.SET_LAST_NAVIGATION](state, values) {
    state.lastNavigation = values;
  },
  [types.SET_MITEL](state, value) {
    state.useMitel = value
  },
  [types.MITEL_LOGIN](state) {
  },
  [types.MITEL_LOGIN_SUCCESS](state) {
    state.mitelIsLoggedIn = true
  },
  [types.MITEL_LOGOUT](state) {
    state.mitelIsLoggedIn = false
  },
  [types.MITEL_LOGIN_SKIP](state) {
    state.mitelIsLoggedIn = false
  },
  [types.SET_LIVEVOX](state, value){
    state.useLiveVox = value;
  },
  [types.LIVEVOX_LOGIN]() {

  },
  [types.LIVEVOX_LOGIN_SKIP](state) {
    state.livevoxIsLoggedIn = false
  },
  [types.LIVEVOX_LOGIN_SUCCESS](state) {
    state.livevoxIsLoggedIn = true
  },
  [types.LIVEVOX_LOGOUT](state) {
    state.livevoxIsLoggedIn = false
  },
  [types.VERINT_LOGIN_SUCCESS](state) {
    state.verintIsLoggedIn = true
  },
  [types.SET_ENABLE_CLIPBOARD_COPY_ON_OUTBOUND_DIAL](state, value) {
    state.enableClipboardCopyOnOutboundDial = value
  }
}

const actions = {
  showNotification({commit}, notification) {
    commit(types.NOTIFY_ERRORS, notification)
  },
  showError({commit}, message) {
    let error = {
      title: 'Error',
      message: message,
      type: 'error'
    }
    commit(types.NOTIFY_ERRORS, error);
  },
  async loadStates({commit, dispatch}) {
    try {
      var result =  await miscAPI.getStates();
      commit(types.LOAD_US_STATES, result.data);
    }
    catch(e) {
      let msg = "There was an error loading the states.";
      dispatch("showError", msg);
      throw msg;
    }
  },
  loadSelectedStates({commit}, selectedStates) {
    commit(types.LOAD_SELECTEDSTATES, selectedStates)
  },
  resetSelectedStates({commit}) {
    commit(types.LOAD_SELECTEDSTATES, []);
  },
  loadMakes({commit}) {
    return miscAPI.getMakes()
      .then((result) =>{
        commit(types.LOAD_MODELS, [])
        commit(types.LOAD_MAKES, result.data.sort((a,b) => {
          if (a.makeName < b.makeName) { return -1 }
          if (a.makeName > b.makeName) { return 1 }
          return 0;
        }))
      })
      .catch(err => {
        commit(types.NOTIFY_ERRORS, err);
        throw new Error(err);
      });
  },
  loadModels({commit}, make) {
    return miscAPI.getModels(make)
      .then((result) =>{
        commit(types.LOAD_MODELS, result.data.sort((a,b) => {
          if (a.modelName < b.modelName) { return -1 }
          if (a.modelName > b.modelName) { return 1 }
          return 0;
        }))
      })
      .catch(err => {
        commit(types.NOTIFY_ERRORS, err);
        throw new Error(err);
      });
  },
  loadFuelTypes({commit}) {
    return miscAPI.getFuelTypes()
      .then((result) =>{
        commit(types.LOAD_FUEL_TYPES, result.data.sort((a,b) => {
          if (a.fuelTypeDescription < b.fuelTypeDescription) { return -1 }
          if (a.fuelTypeDescription > b.fuelTypeDescription) { return 1 }
          return 0;
        }))
      })
      .catch(err => {
        commit(types.NOTIFY_ERRORS, err);
        throw new Error(err);
      });
  },
  async loadEnhancements({ dispatch, commit}) {
    try {
      var result = await miscAPI.getEnhancements();
      commit(types.LOAD_ENHANCEMENTS, result.data);
    }
    catch (e) {
      let msg = "There was an error getting Enhancement Types";
      dispatch('showError', msg, { root: true })
      throw msg;
    }
    // return miscAPI.getEnhancements()
    //   .then((result) =>{
    //     console.log('result enhancements', result)
    //     commit(types.LOAD_ENHANCEMENTS, result.data.data)
    //   })
    //   .catch(err => {
    //     commit(types.NOTIFY_ERRORS, err);
    //     throw new Error(err);
    //   });
  },
  startLoading({commit}, message) {
    commit(types.LOADING_START, message);
  },
  removeLoading({commit}) {
    commit(types.LOADED_SUCCESS)
  },
  // getQuoteStatus({commit}) {
  //   return miscAPI.getQuoteStatus()
  //     .then((result) =>{
  //       console.log('result STATUS', result)
  //       commit(types.LOAD_STATUS, result.data.data)
  //     })
  //     .catch(err => {
  //       commit(types.NOTIFY_ERRORS, err);
  //     });
  // },
  zbValidateEmail({}, emailAddress) {
    return miscAPI.zbValidateEmail(emailAddress);
  },
  getAcceptedDates({commit}) {
    var acceptedDatesList = [];
      var startYear = new Date().getFullYear();
      while (startYear >= 1950){
        acceptedDatesList.push(startYear--);
      };
      commit(types.LOAD_ACCEPTEDDATES, acceptedDatesList);
  },
  setLastNavigation({commit}, to) {
    commit(types.SET_LAST_NAVIGATION, to);
  }

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app-global.js